import { Injectable } from '@angular/core'
import { CompositeFilterDescriptor } from '@progress/kendo-data-query'
import {
  Assistant,
  BdState,
  IaState,
  Note,
  OutsideActivity,
  PersonalAccount,
  RepCode,
  RepFirm,
  RepLicense,
  RepPro,
  RepSocialMedia,
  RepSubscription,
  Solicitor,
} from '../../../models/repEditorModels'

@Injectable({
  providedIn: 'root',
})
export class RepEditorStateService {
  // Rep State
  public repId: number
  public repAssistants: Assistant[]
  public repAssistantsActive: Assistant[]
  public repBdStates: BdState[]
  public repIaStates: IaState[]
  public repLicenses: RepLicense[]
  public repNotes: Note[]
  public repPersonalAccounts: PersonalAccount[]
  public repOutsideActivities: OutsideActivity[]
  public repPros: RepPro[]
  public repFirms: RepFirm[]
  public repCodes: RepCode[]
  public repSocialMedia: RepSocialMedia[]
  public repSolicitors: Solicitor[]
  public repSubscriptions: RepSubscription[]

  // Lookups
  public assistantLookups: any = []
  public stateList: any[]
  public stateListWithInactive: any[]
  public licenseList: any[]
  public noteTypeList: any[]
  public proTypes: any[]
  public firmTypeList: any[]
  public approvedSocialMedia: any[]
  public subscriptions: any[]
  public typesOfFirms: any[]
  public banks: any[]
  public brokerFirms: any[]
  public officeTypes: any[]
  public regions: any[]
  public crdBranchTypes: any[]
  public branches: any[]
  public crdBranches: any[]

  // Page State
  public viewRepsFilters: CompositeFilterDescriptor
  public viewRepsSkip = 0

  public emailAddress: string

  public clearRepState(): void {
    this.repId = null
    this.repAssistants = null
    this.repAssistantsActive = null
    this.repBdStates = null
    this.repIaStates = null
    this.repLicenses = null
    this.repNotes = null
    this.repPersonalAccounts = null
    this.repOutsideActivities = null
    this.repPros = null
    this.repFirms = null
    this.repCodes = null
    this.repSocialMedia = null
    this.repSolicitors = null
    this.repSubscriptions = null
  }

  public getActiveAssistantLookups() {
    return this.assistantLookups.length
      ? this.assistantLookups.filter((l) => l.active)
      : this.assistantLookups
  }
  public getActiveStateList() {
    return this.stateList?.length
      ? this.stateList.filter((l) => l.active)
      : this.stateList
  }
  public getActiveLicenseList() {
    return this.licenseList.length
      ? this.licenseList.filter((l) => l.active)
      : this.licenseList
  }
  public getActiveNoteTypeList() {
    return this.noteTypeList.length
      ? this.noteTypeList.filter((l) => l.active)
      : this.noteTypeList
  }
  public getActiveProTypes() {
    return this.proTypes.length
      ? this.proTypes.filter((l) => l.active)
      : this.proTypes
  }
  public getActiveFirmTypeList() {
    return this.firmTypeList.length
      ? this.firmTypeList.filter((l) => l.active)
      : this.firmTypeList
  }
  public getActiveApprovedSocialMedia() {
    return this.approvedSocialMedia
  }
  public getActiveSubscriptions() {
    return this.subscriptions.length
      ? this.subscriptions.filter((l) => l.active)
      : this.subscriptions
  }
  public getActiveBanks() {
    return this.banks.length ? this.banks.filter((l) => l.active) : this.banks
  }
  public getActiveBrokerFirms() {
    return this.brokerFirms.length
      ? this.brokerFirms.filter((l) => l.active)
      : this.brokerFirms
  }
  public getActiveOfficeTypes() {
    return this.officeTypes.length
      ? this.officeTypes.filter((l) => l.active)
      : this.officeTypes
  }
  public getActiveRegions() {
    return this.regions.length
      ? this.regions.filter((l) => l.active)
      : this.regions
  }
  public getActiveCrdBranchTypes() {
    return this.crdBranchTypes.length
      ? this.crdBranchTypes.filter((l) => l.active)
      : this.crdBranchTypes
  }
  public getActiveBranches() {
    return this.branches.filter((b) => b.active)
  }
  public getActiveTypesOfFirms() {
    return this.typesOfFirms.length
      ? this.typesOfFirms.filter((l) => l.active)
      : this.typesOfFirms
  }
  public getActiveCrdBranches() {
    return this.crdBranches.length
      ? this.crdBranches.filter((l) => l.active)
      : this.crdBranches
  }

  public setViewRepsFilters(filter: CompositeFilterDescriptor) {
    this.viewRepsFilters = filter
  }

  public setViewRepsSkip(event) {
    this.viewRepsSkip = event.skip
  }
}
